<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title flex-end">View List of Pop Up Pages</div>
      <div class="d-flex align-items-center">
        <b-form-input
          v-debounce:300="filterData"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>

        <b-dropdown id="listview" variant="outline-blue" :text="pp_name">
          <b-dropdown-item
            v-for="(list, listIndex) in filterGroup"
            :key="listIndex"
            @click="getSelectedppTypeId(list)"
            href="#"
            >{{ list.pp_name }}</b-dropdown-item
          >
        </b-dropdown>

        <b-dropdown id="listview" variant="outline-blue" :text="status_name">
          <b-dropdown-item
            v-for="(list, listIndex) in ActiveInactivefilterGroup"
            :key="listIndex"
            @click="getSelectedStatus(list)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>

        <router-link
          v-if="
            $can('create', 'Add Pop Up Pages') ||
              $can('create', 'View Pop Up Pages')
          "
          class="btn-blue"
          :to="'/pop-up-pages/add-popup-page'"
          >{{ $t("Add") }}</router-link
        >

        <!-- <button @click="filterData()" class="btn-blue">Fetch</button> -->
      </div>
    </div>
    <div>
      <div class="col-md-12" style="overflow-x: scroll">
        <div class="row">
          <div class="col-md-12">
            <table class="list-view-table">
              <thead>
                <tr>
                  <th>Status</th>
                  <th v-if="$can('update', 'Add Pop Up Pages')"></th>
                  <th style="width: 120px;">Page Name</th>
                  <th style="width:100px">Language</th>
                  <th>Title</th>
                  <th style="width: 150px;">From Date</th>
                  <th style="width: 150px;">To Date</th>
                  <!-- <th>Description</th> -->
                  <th>Image</th>
                </tr>
              </thead>
              <tbody v-if="pagesData.length > 0">
                <tr v-for="(item, index) in pagesData" :key="index">
                  <td>
                    <span @click="onClickStatusDot(item)">
                      <StatusDot
                        :status="item.is_active == 'Y' ? 'active' : 'inactive'"
                      />
                    </span>
                  </td>
                  <!-- <td
                    class="text-right"
                    v-if="
                      $can('update', 'Add Pop Up Pages') ||
                      $can('update', 'View Pop Up Pages')
                    "
                  >
                    <b-dropdown right variant="edit" class="ml-4">
                      <b-dropdown-item
                        @click="goToRoute('/pages/edit-popup-page', item)"
                      >
                        <span class="edit-pen"></span>
                        {{ $t("edit") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </td> -->
                  <td
                    class="text-right"
                    v-if="
                      $can('update', 'Add Pop Up Pages') ||
                        $can('update', 'View Pop Up Pages')
                    "
                  >
                    <i
                      class="edit-pen icon blue-icon cursor-pointer ml-4"
                      @click.prevent.stop="
                        goToRoute('/pages/edit-popup-page', item)
                      "
                      v-b-tooltip="'Edit'"
                      tabindex="0"
                    ></i>
                  </td>

                  <td>
                    {{ item.pp_name }}
                    {{ item.rating ? `(${item.rating})` : "" }}
                  </td>
                  <td>{{ item.lang_name }}</td>
                  <td>{{ item.pp_title }}</td>
                  <td>{{ item.fromDate ? formattedDate(item.fromDate):"-" }}</td>
                  <td>{{ item.toDate ? formattedDate(item.toDate ) : "-" }}</td>

                  <!-- <td v-html="item.pp_description"></td> -->
                  <td>
                    <div class="image-placeholder">
                      <img
                        :src="
                          item.pp_banner.startsWith('http')
                            ? item.pp_banner.replace(/([^:]\/)\/+/g, '$1')
                            : item.pp_banner.startsWith('S3') ||
                              item.pp_banner.startsWith('/S3')
                            ? IMGBASEURL + item.pp_banner
                            : item.pp_banner
                        "
                        width="100"
                        height="100"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="pagesData.length == 0">
                <tr>
                  <td colspan="3">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3">
          Are you sure you want to
          {{ selectedPop.is_active == "Y" ? "Inactive" : "Active" }} this Pop
          Page?
        </p>
        <span class="mx-1"></span>
        <button
          v-if="selectedPop.is_active == 'N'"
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('Y')"
        >
          Active
        </button>
        <button
          v-else
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('N')"
        >
          Inactive
        </button>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import ExhibitorService from "@/services/ExhibitorService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import { IMGBASEURL } from "@/config/index.js";
  import _ from "lodash";

  export default {
    name: "View Pop Up Pages",
    components: {
      StatusDot,
      NoRecords,
    },
    data() {
      return {
        searchValue: "",
        dropdownstatus: [
          { id: 1, value: "", name: "All" },
          { id: 2, value: "Y", name: "Active" },
          { id: 3, value: "N", name: "Inactive" },
        ],
        selectedDropdownStatus: "",
        pagesData: [],
        pp_type_id: "",
        pp_name: "Select Filter",
        status_name: "Active",
        is_active: "Y",
        IMGBASEURL: IMGBASEURL,
        listContent: "Select Filter",
        selectedPop: {
          pp_id: null,
          pp_type_id: null,
          pp_name: "",
          pp_lang_id: null,
          pp_rating_type: "",
          pp_banner: "",
          pp_title: "",
          pp_country_id: "",
          pp_image_url: "",
          pp_description: "",
          is_active: "Y",
        },
        filterGroup: [
          {
            pp_name: "All",
            pp_type_id: "",
          },
          {
            pp_name: "PopUp",
            pp_type_id: "1",
          },
          {
            pp_name: "Rating",
            pp_type_id: "2",
          },
        ],
        ActiveInactivefilterGroup: [
          {
            name: "All",
            is_active: "",
          },
          {
            name: "Active",
            is_active: "Y",
          },
          {
            name: "In Active",
            is_active: "N",
          },
        ],
      };
    },

    watch: {
      selectedDropdownStatus(status) {
        this.selectedDropdownStatus = status;
      },
    },
    beforeMount() {
      // this.getListOfPopUpPages();
      this.filterData();
    },
    methods: {
      formattedDate(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
      UpdateStatus(status) {
        let loader = this.$loading.show();
        this.$bvModal.hide("confirmation_active_inactive");

        let payload = {
          pp_id: this.selectedPop["pp_id"],
          is_active: status
            ? status
            : this.selectedPop["is_active"] == "Y"
            ? "N"
            : "Y",
        };
        ExhibitorService.UpdatePopupPageStatus(payload)
          .then((response) => {
            const { data } = response;
            this.getListOfPopUpPages();
            console.log(data.message);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onClickStatusDot(item) {
        console.log("CLICKING onClickStatusDot", item);
        this.selectedPop = _.cloneDeep(item);
        this.$bvModal.show("confirmation_active_inactive");
      },
      getListOfPopUpPages() {
        let payload = {
          is_active: this.selectedDropdownStatus.value,
        };
        ExhibitorService.GetListOfPopUpPages(payload)
          .then((response) => {
            const { data } = response;
            if (data.Records.length > 0) {
              //console.log(data.Records);
              // this.pagesData = data.Records;
              let pageData = data.Records;
              this.pagesData = pageData;
            } else {
              //console.log("data.message", data.message);
            }
          })
          .catch((error) => {
            //console.log(error);
          });
      },
      goToRoute: function(path, item) {
        const { pp_id } = item;
        this.$router.push({
          path: path,
          query: {
            pp_id: pp_id,
          },
        });
      },
      getSelectedppTypeId(item) {
        this.pp_name = item.pp_name;
        this.pp_type_id = item.pp_type_id;
        this.filterData();
      },
      getSelectedStatus(data) {
        this.status_name = data.name;
        this.is_active = data.is_active;
        this.filterData();
      },
      filterData() {
        // this.pp_type_id = item.pp_type_id;
        // this.is_active = item.is_active;
        let payload = {
          pp_type_id: this.pp_type_id,
          is_active: this.is_active,
          searchValue: this.searchValue,
        };
        ExhibitorService.GetListOfPopUpPages(payload)
          .then((response) => {
            const { data } = response;
            if (data.Records.length > 0) {
              console.log(data.Records);
              let pageData = data.Records;
              this.pagesData = pageData;
            } else {
              this.pagesData = [];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/viewListOfPopUpPages.vue